import { jwtDecode } from "jwt-decode";

const LIVE_APPLICATION_NAME = 'Live';

export const checkAccessToLive = (token) => {
	const tokenPayload = jwtDecode(token);

	if (!tokenPayload) {
		throw new Error();
	}

	if (!tokenPayload.resource_access) {
		throw new Error();
	}

	return tokenPayload.resource_access[LIVE_APPLICATION_NAME + '_ACCESS'];
};
